import { FormatOptionLabelMeta } from "react-select";
import { colors } from "./variable";

import {
  CSSProperties,
  KeyboardEventHandler,
  MouseEventHandler,
  ReactNode,
  Ref,
} from "react";

export const defaultFileTypes = [
  "JPG",
  "PNG",
  "GIF",
  "SVG",
  "PDF",
  "DOC",
  "DOCX",
  "XLS",
  "XLSX",
  "PPT",
  "PPTX",
  "TXT",
  "RTF",
  "MP3",
  "WAV",
  "MP4",
  "MOV",
  "AVI",
  "MKV",
  "ZIP",
  "RAR",
  "7Z",
  "JSON",
  "CSV",
  "XML",
];
export interface RavenInputProps {
  minValue?: number | string;
  maxValue?: number | string;
  color?: colors["value"];
  value?: any;
  name?: string;
  pinType?: string;
  id?: string;
  className?: string;
  style?: CSSProperties;
  label?: ReactNode;
  type?: string;
  onChange?: any;
  placeholder?: string;
  errorText?: string;
  showError?: true | false;
  format?: string;
  selectOption?: any;
  selectOptionLabel?:
     ((
        data: any,
        formatOptionLabelMeta: FormatOptionLabelMeta<any>
      ) => ReactNode)
    | undefined;
  selectStyles?: any;
  selectValue?: any;
  disabled?: true | false;
  loading?: true | false;
  searchable?: boolean;
  multi?: boolean;
  selectClassName?: any;
  textareaColumn?: any;
  textareaRow?: any;
  numberPrefix?: any;
  labelClassName?: any;
  showColor?: string;
  onActionClick?: any;
  labelColor?: colors["value"];
  labelSpanText?: string;
  showPasswordStrength?: boolean;
  onSubmit?: any;
  onComplete?: any;
  pinFieldNumber?: number;
  countDownTime?: any;
  onCountDownComplete?: any;
  showCountDown?: boolean;
  textColor?: colors["value"];
  thousandFormat?: boolean;
  onSizeError?: any;
  maxSize?: any;
  onRemoveFile?: any;
  enableTime?: boolean;
  selectMenuOpen?: any;
  min?: number | undefined;
  max?: number | undefined;
  showValue?: boolean;
  menuPlacement?: any;
  removeAutoComplete?: boolean;
  pinId?: string;
  pinRef?: Ref<HTMLInputElement[] | null> | undefined;
  uploadSpan?: string | undefined;
  upploadText?: string | undefined;
  scheduleFormat?: string | undefined;
  loadingSelect?: boolean;
  maxLength?: number | undefined;
  decimalScale?: any | undefined;
  dateOptions?: object | undefined;
  minuteIncrement?: number | undefined;
  purpleGradient?: true | false;
  additionalValue?: string | undefined;
  numberUp?: () => void;
  numberDown?: () => void;
  range?: number;
  numberSpinner?: true | false;
  rangeStep?: number | false;
  countdownFinishClick?: () => void;
  countdownFinishText?: string;
  countdownFinishClassName?: string;
  countdownFinishTextClassName?: string;
  countdownLabelClassName?: string;
  selectComponents?: any;
  loaderColor?: string | undefined;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  onKeyUp?: KeyboardEventHandler<HTMLInputElement>;
  onMouseEnter?: MouseEventHandler<HTMLInputElement>;
  onMouseLeave?: MouseEventHandler<HTMLInputElement>;
  onMouseMove?: MouseEventHandler<HTMLInputElement>;
  onMouseOut?: MouseEventHandler<HTMLInputElement>;
  onMouseOver?: MouseEventHandler<HTMLInputElement>;
  onMouseDown?: MouseEventHandler<HTMLInputElement>;
  onMouseUp?: MouseEventHandler<HTMLInputElement>;
  loaderText?: string;
  readOnly?: boolean;
  strengthColor?: colors;
  onFocus?: () => void;
  onInputBlur?: () => void;
  onInputFocus?: () => void;
  onBlur?: () => void;
  onMenuOpen?: () => void;
  capitalize?: boolean;
  openGuessBox?: boolean;
  inputPattern?: string;
  numberSuffix?: string;
  inputMode?:
    | "text"
    | "tel"
    | "search"
    | "email"
    | "none"
    | "url"
    | "numeric"
    | "decimal";
  customPreviewSrc?: string | File;
  customPreviewName?: string;
  customPreviewSize?: string;
  uploadComponentChildren?: ReactNode;
  fileTypes?: keyof typeof defaultFileTypes;
  onTypeError?: (error: any) => any;
  allowNegative?: boolean;
  onImgClick?: any;
}
